module.exports = __webpack_public_path__ + "img/7.bb6c5601.png";